export const environment = {
    urlBase:"https://api.recaudarsinu.com",
    frontendUrl: "https://recaudarsinu.com"
}